// extracted by mini-css-extract-plugin
export default {"slider-area":"SliderArea_slider-area__ckn7L"};